import { HttpAreaList, HttChangeActive } from "@/service/basicdata";
import TableList from "@components/templates/tablelist";
import { mapGetters } from "vuex";
import mixin from "./mixin";
import comIndex from "./update";
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            formData: {
                search: {},
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpAreaList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(
                        this.$t("global.common.choose_one", {
                            defaultValue: "请选择至少一条数据",
                        })
                    );
            }
            switch (type) {
                case "add":
                    this.operate = {
                        title: this.$t("", { defaultValue: "添加区域" }),
                        show: true,
                        width: 500,
                        component: "comIndex",
                        type: "add",
                        showFooter: false,
                    };
                    break;
                case "edit":
                    this.operate = {
                        title: this.$t("global.common.operation_edit", {
                            defaultValue: "编辑",
                        }),
                        show: true,
                        width: 500,
                        component: "comIndex",
                        activeid: params,
                        type: "edit",
                        showFooter: false,
                    };
                    break;
                case "InActive":
                    this.operate = {
                        title: this.$t("", { defaultValue: "失效" }),
                        show: true,
                        alert: "error",
                        params: { id: params, active: 0 },
                        ajaxRequest: HttChangeActive,
                    };
                    break;
                case "active":
                    this.operate = {
                        title: this.$t("", { defaultValue: "激活" }),
                        show: true,
                        alert: "info",
                        params: { id: params, active: 1 },
                        ajaxRequest: HttChangeActive,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, active } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: id,
                    operate: "edit",
                },
                {
                    label: "失效",
                    show: active == 1,
                    params: id,
                    operate: "InActive",
                },
                {
                    label: "激活",
                    show: active == 0,
                    params: id,
                    operate: "active",
                },
            ];
        },
    },
    computed: {
        ...mapGetters("dictionary", ["getCountryList"]),
        ToolsData() {
            return [
                {
                    name: this.$t("global.common.add", {
                        defaultValue: "添加",
                    }),
                    operate: "add",
                    theme: "primary",
                },
            ];
        },
        SearchsData() {
            return [
                {
                    label: this.$t("", { defaultValue: "区域名称" }),
                    key: "EQ_areaName",
                    tag: "vInput",
                    show: true,
                },
                {
                    label: this.$t("", { defaultValue: "状态" }),
                    key: "EQ_active",
                    tag: "vSelect",
                    show: true,
                    options: this.getActives,
                },
            ];
        },
        columns() {
            return [
                {
                    title: this.$t("global.common.actions", {
                        defaultValue: "操作",
                    }),
                    width: 100,
                    render: this.getOperateNodes,
                },
                {
                    title: this.$t("", { defaultValue: "区域名称" }),
                    key: "areaName",
                },
                {
                    title: this.$t("", { defaultValue: "国家" }),
                    key: "regionCode",
                    render: (h, { row }) => {
                        const country = this.getCountryList.map((item) => {
                            return {
                                label: item.label,
                                value: item.value,
                            };
                        });
                        return this.findRenderLabel(country, row.regionCode);
                    },
                },
                {
                    title: this.$t("", { defaultValue: "船期(天)" }),
                    key: "sailSchedule",
                },
                {
                    title: this.$t("", { defaultValue: "描述" }),
                    key: "description",
                },
                {
                    title: this.$t("", { defaultValue: "状态" }),
                    key: "active",
                    render: (h, { row }) =>
                        this.findRenderLabel(this.getActives, row.active),
                },
                {
                    title: this.$t("fbb.adjustment.created_name", {
                        defaultValue: "创建人",
                    }),
                    key: "createdName",
                },
                {
                    title: this.$t("", { defaultValue: "更新时间" }),
                    key: "updatedAt",
                },
            ];
        },
    },
};
